if (process.env.NODE_ENV === 'production') {
  module.exports = require('./Root.prod')
} else if (process.env.CONFIG === 'localazure') {
  module.exports = require('./Root.hashdev')
} else {
  module.exports = require('./Root.dev')
}
